<script setup>
import { getI18n } from '@/plugins/i18n'
import { useArchive } from '@/composables/archive'
import { useApps } from '@/composables/device'
import { usePlanningStore } from '@/stores/planning.store'

import ListItem from '@/components/shared/ListItem.vue'

defineProps({
  contact: {
    type: Object,
    required: true,
  },
})

const { t } = getI18n()
const { archivedChip } = useArchive()
const { phoneCall, whatsappMessage, emailOpen } = useApps()

const planningStore = usePlanningStore()

const getCaptionChips = (contact) => [
  contact.is_default ? { label: t('company.defaultContact'), color: 'primary', textColor: 'white', size: 'sm' } : null,
  contact.archived ? archivedChip : null,
].filter(Boolean)
</script>

<template>
  <list-item
    v-bind="$attrs"
    :avatar="contact.avatar_file || contact.avatar_url"
    avatar-icon="mdi-account"
    :label="planningStore.getContactName(contact)"
    :caption="contact.role || undefined"
    :caption-chips="getCaptionChips(contact)"
    :disabled="contact.archived"
  >
    <template #right>
      <div class="row items-center no-wrap" style="gap: .5rem;">
        <q-btn
          v-if="contact.default_email"
          round
          flat
          size="1rem"
          style="margin: 0;"
          icon="mdi-email"
          color="orange"
          @click.stop="emailOpen(contact.default_email)"
        />
        <q-btn
          v-if="contact.default_phone"
          round
          flat
          size="1rem"
          style="margin: 0;"
          icon="mdi-whatsapp"
          color="positive"
          @click.stop="whatsappMessage(contact.default_phone)"
        />
        <q-btn
          v-if="contact.default_phone"
          round
          flat
          size="1rem"
          style="margin: 0;"
          icon="mdi-phone"
          color="blue"
          @click.stop="phoneCall(contact.default_phone)"
        />
      </div>
    </template>
  </list-item>
</template>
